// extracted by mini-css-extract-plugin
export default {"brandPromo":"QG-z","carousel":"RG-z"};